import { render } from "./TaxRates.vue?vue&type=template&id=b7121f46&scoped=true"
import script from "./TaxRates.vue?vue&type=script&lang=js"
export * from "./TaxRates.vue?vue&type=script&lang=js"

import "./TaxRates.vue?vue&type=style&index=0&id=b7121f46&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7121f46"]])

export default __exports__